<ng-container *ngIf="!externalViewer">
  <div
      *ngIf="configuredViewer !== 'pdf'"
      [innerHtml]="docHtml"
  ></div>
  <embed
      *ngIf="configuredViewer === 'pdf'"
      type="application/pdf"
      [src]="fullUrl"
      style="width: 100%; height: 100%;"
  />
</ng-container>
<ng-container *ngIf="externalViewer">
  <iframe
      *ngIf="fullUrl && disableContent === 'none'"
      id="iframe"
      frameBorder="0"
      [src]="fullUrl"
      title="maindocUp"
  ></iframe>
  <div
      class="container"
      *ngIf="disableContent !== 'none'"
  >
      <div
          [class.overlay-full]="disableContent === 'all'"
          [class.overlay-popout-google]="configuredViewer ==='google' && (disableContent === 'popout' || disableContent === 'popout-hide')"
          [class.overlay-popout-office]="configuredViewer ==='office' && (disableContent === 'popout' || disableContent === 'popout-hide')"
          [style.background-color]="disableContent === 'popout-hide' ? '#fff': 'transparent'"
      >
      </div>
      <iframe
          *ngIf="fullUrl"
          id="iframe"
          frameBorder="0"
          [src]="fullUrl"
          title="maindocUp"
      ></iframe>
  </div>
</ng-container>
